import { Link } from "gatsby"
import React from 'react'
import PJL from '../assets/pericia-judicial-logo.png'

const Header = ({ children }) => {
    return (
            <div className='w-auto bg-color-al-4  flex-wrap justify-center              lg:justify-between items-center text-center lg:text-left '>
                        <div>
                            <div className='items-center animation-ronsof-one text-red-600 mx-4 lg:mx-0 xl:mx-0'>
                                <h1>
                                     Entregamos em 
                                </h1> 
                                <h1>
                                     Itaquaquecetuba 
                                </h1> 
                                <h1>
                                     e região
                                </h1>  
                            </div>
                            
                            <p className='animation-ronsof-one font-ronsof-nine  text- font-size-ronsof-p6'>
                                Tudo em bolos decorativos
                            </p>
                            <p className='animation-ronsof-one font-ronsof-nine text-blue-700 font-size-ronsof-p6'>
                                doces e Salgados
                            </p>
                        </div>
                        <div className='my-2 md:my-20 lg:my-5 lg:pt-5'>
                            <Link to={`/pagecontato`} className="btn-ronsof-one-green-sb shadow-lg">
                                Faça seu pedido aqui
                            </Link>
                        </div>
                   
            </div>
      
    )
}
export default Header